/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteProfiloDto } from '../../models/utente-profilo-dto';

export interface ApiAuthUtenteProfiloGet$Params {
    /**
     * Id dell'utente per cui si vuole caricare il profilo
     */
    utenteId: number;
}

export function apiAuthUtenteProfiloGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthUtenteProfiloGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<UtenteProfiloDto>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteProfiloGet.PATH, 'get');
    if (params) {
        rb.query('utenteId', params.utenteId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<UtenteProfiloDto>;
        }),
    );
}

apiAuthUtenteProfiloGet.PATH = '/api/auth/utente-profilo';
